import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BreadcrumbComponent as Breadcrumb, BreadcrumbItemDirective } from 'xng-breadcrumb';

/**
 * wrapper component for ngx-breadcrumb {@link https://udayvunnam.github.io/xng-breadcrumb}
 * inside of the implementation several keys are available to identify the
 * items in the context of *xngBreadcrumbItem.
 * info, first, last and index are passed to identify the respective items.
 * in order to set an icon for an item the key info needs to be an object of type {@link IBreadcrumb}
 * @class BreadcrumbComponent
 * @typedef {BreadcrumbComponent}
 */
@Component({
    standalone: true,
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    imports: [NgIf, Breadcrumb, BreadcrumbItemDirective, MatIconModule]
})
export class BreadcrumbComponent {}
